import React, { useState, useEffect, useRef } from 'react';
import section3Video from './section3_2.mp4';
import './Section3.css';

const Section3 = () => {
  const [textFadeProgress, setTextFadeProgress] = useState(0);
  const [videoFadeProgress, setVideoFadeProgress] = useState(1);
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const containerRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const rect = container.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Text + Video fade in as section enters (rect.top: viewportHeight -> 0)
      if (rect.top > 0) {
        const progress = Math.max(0, Math.min(1, 1 - (rect.top / viewportHeight)));
        setTextFadeProgress(progress);
        setVideoFadeProgress(progress);
      }
      // Video fades out as section exits (rect.top: 0 -> -viewportHeight)
      else if (rect.top <= 0 && rect.top > -viewportHeight) {
        setTextFadeProgress(1);
        const progress = 1 + (rect.top / viewportHeight);
        setVideoFadeProgress(Math.max(0, Math.min(1, progress)));
      }
      // Section completely scrolled past
      else {
        setTextFadeProgress(1);
        setVideoFadeProgress(0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleVideoReady = () => {
    setIsVideoLoading(false);
  };

  // Start video autoplay when component mounts
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
    }
  }, []);

  return (
    <section className="section3-container" ref={containerRef}>
      <div className="section3-content">

        {/* Left Side: Text Content */}
        <div className="section3-left">
          <div
            className="section3-text-wrapper"
            style={{
              opacity: textFadeProgress
            }}
          >
            <h2 className="section3-title">Change on Plan, Change on alls</h2>
            <p className="section3-body">
            Make a single design tweak in the plan—like moving a wall or rounding a corner—and the system instantly propagates that change across every dimension. From the overarching massing model down to the detailed elevations and live project statistics, everything updates automatically.
            </p>
          </div>
        </div>

        {/* Right Side: Video */}
        <div className="section3-right">
          <video
            ref={videoRef}
            className="section3-video"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            onLoadedData={handleVideoReady}
            onCanPlay={handleVideoReady}
            onError={handleVideoReady}
            src={section3Video}
            style={{
              opacity: videoFadeProgress
            }}
          />
          {isVideoLoading && (
            <div className="section3-video-loader" aria-live="polite">
              <div className="section3-video-spinner" />
              <span className="section3-video-loader-text">Loading demo...</span>
            </div>
          )}
        </div>

      </div>
    </section>
  );
};

export default Section3;
